const API_KEY = 'testApiKey';
const API_SECRET_KEY = 'testApiSecretKey';
const APP_URL = 'https://my-test-app.myshopify.io';
const TEST_SHOP_NAME = 'test-shop';
const TEST_SHOP = `${TEST_SHOP_NAME}.myshopify.com`;
const SHOPIFY_HOST = `admin.shopify.com/store/${TEST_SHOP_NAME}`;
const BASE64_HOST = Buffer.from(SHOPIFY_HOST).toString('base64');
const USER_ID = 12345;

export { API_KEY, API_SECRET_KEY, APP_URL, BASE64_HOST, SHOPIFY_HOST, TEST_SHOP, TEST_SHOP_NAME, USER_ID };
//# sourceMappingURL=const.mjs.map
